import { render, staticRenderFns } from "./keyboard_arrow_left_gray.svg?vue&type=template&id=8ba542ea&inline"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports